import request from 'src/shared/utils/requester';
import getUserHeadquarterList from 'src/user-headquarter/use-cases/getUserHeadquarterList';

const authorizeUser = async (email, password) => {
  const method = 'POST';
  const url = 'users/authorize';

  const body = {
    email,
    password
  };

  const json = await request({ method, url, body });
  const { accessToken, user } = json;

  localStorage.accessToken = accessToken;
  localStorage.user = JSON.stringify(user);

  const userHeadquarterList = await getUserHeadquarterList();
  if (!userHeadquarterList || userHeadquarterList.error) {
    return userHeadquarterList;
  }

  localStorage.userHeadquarterList = JSON.stringify(userHeadquarterList);
  if (!localStorage.selectedUserHeadquarter) {
    localStorage.selectedUserHeadquarter = JSON.parse(
      localStorage.userHeadquarterList
    )[0].CompanyHeadquarter.id;
  }

  localStorage.____________________ = JSON.stringify({ email, password });

  return json;
};

export default authorizeUser;
